import { supabase } from '@/integrations/supabase/client';
import { config } from '@/lib/config';

/**
 * Triggers background YouTube video analysis via the backend API.
 * This is a fire-and-forget operation that enhances video metadata without blocking the user experience.
 */
export const triggerYouTubeAnalysis = async (videoId: string, topicId: string): Promise<void> => {
  try {
    // Get authentication token
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
      console.warn('⚠️ No auth token available for YouTube analysis');
      return;
    }

    console.log('🧠 Triggering YouTube analysis for video:', videoId);

    // Call backend API to trigger analysis
    const response = await fetch(`${config.BACKEND_API_URL}/api/youtube/analyze/${videoId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ 
        topic_id: topicId,
        analysis_type: 'summary'
      }),
    });

    if (response.ok) {
      console.log('✅ YouTube analysis triggered successfully for video:', videoId);
    } else {
      console.warn('⚠️ YouTube analysis request failed:', response.status, response.statusText);
    }
  } catch (error) {
    // Non-blocking error - analysis failure shouldn't affect user experience
    console.warn('⚠️ YouTube analysis failed (non-blocking):', error);
  }
};
